<ion-content class="ion-padding">
  <ion-icon
    class="close-icon"
    name="close-outline"
    (click)="cancel()"
  ></ion-icon>
  <ng-container *ngIf="(solicitacoes$ | async) as solicitacoes">
    <div class="header">
      <h2>{{ periodo | date: 'MMMM YYYY' | titlecase }}</h2>
      <div class="tab" [class.selected]="tabSelected == 'pendentes'" (click)="handleChangeTab('pendentes')">{{solicitacoes.pendentes.length}} solicitações pendentes</div>
      <div class="tab" [class.selected]="tabSelected == 'concretizadas'" (click)="handleChangeTab('concretizadas')">{{ solicitacoes.concretizadas.length }} solicitações concretizadas</div>
      <div class="tab" (click)="handleShowMore()">Outros Meses</div>
    </div>

    <div class="slider">
      <div class="slides" #slidesContainer>
        <ng-container >
          <scale-change-request-card
          style="flex: 0 0 420px;"
            *ngFor="let solicitacao of solicitacoes[tabSelected]"
            [requestData]="solicitacao"
            (reprove)="reprove(solicitacao)"
            (approve)="confirmSolicitacaoTroca(solicitacao)"
            [showFooter]="tabSelected == 'pendentes' ? true : false"
          />
        </ng-container>
      </div>
    </div>
  </ng-container>
</ion-content>
